import React, { useState, useContext } from 'react';
import { Card, Badge } from 'react-bootstrap';
import DealContext from '../DealContext';
import Form from '../../form/Form';
import { modal } from '../../modal/ModalEmitter';
import ApiService from '../../../services/ApiService';

const CustomerCard = () => {
  const [editCust, setEditCust] = useState(false);
  const { deal, presentCustomer } = useContext(DealContext);

  const hasCustomer = !!deal.Customer;

  const handleCustomerSubmit = payload => {
    const { customerId } = payload;

    if (!customerId) {
      modal.error('Error', 'Invalid customer selected');
      return;
    }

    // TODO This updates the salestaxrate but does take into account other changes as a result or in the event of a dirty form
    return ApiService.put(`crm/deal/${String(deal.id)}/change-customer`, { customerId }).then(() => {
      // return ApiService.put(`db/EQS2/${deal.id}`, { customerId }).then(() => {
      presentCustomer(customerId);

      // Just so the user doesnt see this go back to displayonly with the old info before a rerender
      setTimeout(() => {
        setEditCust(false);
      });
    });
  };

  return (
    <Card className="customer-card">
      <div className="card-toolbar">
        {editCust === true ? (
          <div className="card-toolbar-button" title="Cancel" onClick={() => setEditCust(false)}>
            <i style={{ color: 'var(--red-5)' }} className="fas fa-times fa-fw" />
          </div>
        ) : (
          <div className="card-toolbar-button" onClick={() => setEditCust(true)}>
            <i className="fas fa-pen fa-fw" />
          </div>
        )}
      </div>
      <Card.Body>
        <Card.Title>Customer</Card.Title>
        {hasCustomer === true && editCust === false ? (
          <>
            {`${deal.Customer.fullName} ${
              deal.Customer['Company Name'] !== deal.Customer.fullName ? `(${deal.Customer['Company Name']})` : ''
            }`}
            <br />
            {deal.Customer.Address}
            <br />
            {deal.Customer.City} {deal.Customer.State} {deal.Customer.Zip}
            <br />
            {deal.Customer.Phone}
            <h4 onClick={presentCustomer} style={{ cursor: 'pointer' }}>
              <Badge variant="success" className="h2 float-right mb-0">
                {deal.customerId}
              </Badge>
            </h4>
          </>
        ) : (
          <Form
            layout={[
              {
                control: 'paragraph',
                style: 'warning',
                data: 'Changing the customer can impact sales tax on existing quotes.',
                name: 'warn',
                label: 'warning',
              },
              {
                name: 'customerId',
                label: 'Choose Existing or Create New',
                toolbar: [{ action: 'add', pageName: 'EQS5' }],
                validation: {
                  page: 'EQS5',
                  type: 'customer',
                },
                required: true,
                data: hasCustomer ? deal.Customer.itemid : '',
              },
            ]}
            exportFormat="object"
            hideCancel
            submit={handleCustomerSubmit}
            submitLabel="Select Customer"
          />
        )}
      </Card.Body>
    </Card>
  );
};

export default CustomerCard;
